/**
 * @file draft-po-group.tsx
 * @module app/modules/uProcure/po-management/draft-po-group
 * @description The supplier group of a draft PO (Vendor Profile > Groups): its name, or "No group"
 *   when the supplier has groups and this draft is for products in none. Nothing for suppliers
 *   without groups (one draft, as before).
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.4.0
 * @version 1.4.0
 */

export interface DraftGroupFields {
  supplierGroup?: { reference: string; name: string } | null;
  supplierHasGroups?: boolean;
}

/** "Mill" / "No group" / "" */
export const draftGroupLabel = (d: DraftGroupFields) => (d.supplierGroup ? d.supplierGroup.name : d.supplierHasGroups ? "No group" : "");

export const DraftGroupBadge = ({ draft }: { draft: DraftGroupFields }) => {
  const label = draftGroupLabel(draft);
  if (!label) return null;
  return (
    <span className={`badge ms-2 ${draft.supplierGroup ? "badge-light-primary" : "badge-light-warning"}`} title="Supplier group (Vendor Profile > Groups)" data-testid="draft-group">
      {label}
    </span>
  );
};
